<template>
    <sa-page-layout>
        <template slot="toolbar">
            <b-button variant="secondary btn-toolbar float-sm-right sa-margin-right" size="sm"
                @click="onClickTornaAllaLista"><i class="fas fa-list"></i>Torna alla lista</b-button>
        </template>
        <template slot="table-body">
            <div class="p-6">
                <AccettazioneSsnSchedaPazienteComponent ref="cmpAccettazioneSsnSchedaPazienteComponent" />
            </div>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import AccettazioneSsnSchedaPazienteComponent from "../components/AccettazioneSsnSchedaPazienteComponent.vue"

export default {
    components: { SaPageLayout, AccettazioneSsnSchedaPazienteComponent },
    data() {
        return {
            id: null
        }
    },
    mounted() {
        if (!this.$route.params.id) {
            this.$router.push("/accettazionessn")
        }
        this.id = this.$route.params.id;
        this.loadDataSchedaPazienteAccettazione();
    },
    methods: {
        onClickTornaAllaLista() {
            this.$router.push("/accettazionessn");
        },
        loadDataSchedaPazienteAccettazione() {
            this.$refs.cmpAccettazioneSsnSchedaPazienteComponent.init(this.id);
        }

    }

}
</script>

<style lang="scss" scoped></style>